import '@/assets/iconfont';
import './styles/index.scss';
import 'element-plus/dist/index.css'
// v-loading指令样式
import 'element-plus/theme-chalk/el-loading.css';

import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import App from '@/App.vue';
import ElementPlus from 'element-plus'
import { createApp } from 'vue';
import router from './router';
// import { setupDirective } from '@/directive';
import { setupStore } from '@/store';
import { vLoading } from 'element-plus';

const app = createApp(App);
app.use(ElementPlus)
// 全局状态
setupStore(app);
// setupDirective(app);
// 全局方法
app.directive('loading', vLoading);

app.use(router);
app.mount('#app');

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
